<template>
  <div>
    <template v-if="target.id">
      <div class="target-details__platform">
        <div>
        <div><b>Target Name: </b>{{target.display_name}}</div>
        <div><b>Advertiser: </b>{{target.advertiser.Name}}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    target: {
      type: Object,
      default: {}
    }
  }
}
</script>

<style lang="scss">
.target-details{
  &__platform {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// TargetDetails.vue?7c1a905c